import React from "react";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div>
          <strong>Refund Policy:</strong> Full refund if cancelled within 24 hours of placing the order.
          Processed within 5 working days.
        </div>
        <div>
          <strong>Contact:</strong>{" "}
          <a href="mailto:info@behaviourtherapy.in" style={{ color: "#ffde59" }}>
            info@behaviourtherapy.in
          </a>{" "}
          |{" "}
          <a href="tel:+918054136594" style={{ color: "#ffde59" }}>
            +91-8054136594
          </a>
        </div>
        <div>
          <strong>Delivery:</strong> Customized home plan delivered within 7
          working days after payment.
        </div>
      </div>
    </footer>
  );
}
         
